/* eslint-disable max-len */
import { createAction, props } from '@ngrx/store';

import { OrderChangeItem, OrderChangeOption, OrderChangeStep } from '../../models/changes.models';

import { Address } from '@api/address/models/address.models';
import { ProductColor, ProductSize } from '@api/catalog/products/products.models';
import { Order } from '@api/order/order.models';
import { PickupPointInfo } from '@api/store-locator/droppoint-lists/models/droppoint-lists.models';
import { PhysicalStoreDetail } from '@api/store-locator/physical-store/models/physical-store.models';

export const OrderChangeActions = {
    SET_CHANGE_ORDER: '[Order change] SET_CHANGE_ORDER',
    SET_CHANGE_STEP: '[Order change] SET_CHANGE_STEP',
    SET_SELECTED_ITEM: '[Order change] SET_SELECTED_ITEM',
    NEXT_CHANGE_STEP: '[Order change] NEXT_CHANGE_STEP',
    SET_SELECTED_COLOR: '[Order change] SET_SELECTED_COLOR',
    SET_SELECTED_SIZE: '[Order change] SET_SELECTED_SIZE',
    SET_ORDER_CHANGE_ADDRESS: '[Order change] SET_ORDER_CHANGE_ADDRESS',
    SET_CHANGE_RETURN_OPTION: '[Order change] SET_CHANGE_RETURN_OPTION',
    SET_CHANGE_DELIVERY_OPTION: '[Order change] SET_CHANGE_DELIVERY_OPTION',
    SET_CHANGE_RETURN_POINT: '[Order change] SET_CHANGE_RETURN_POINT',
    SET_CHANGE_DELIVERY_POINT: '[Order change] SET_CHANGE_DELIVERY_POINT',
    SET_CHANGE_RETURN_STORE: '[Order change] SET_CHANGE_RETURN_STORE',
    SET_CHANGE_DELIVERY_STORE: '[Order change] SET_CHANGE_DELIVERY_STORE',
    SET_CHANGE_RETURN_HOME: '[Order change] SET_CHANGE_RETURN_HOME',
    SET_CHANGE_DELIVERY_HOME: '[Order change] SET_CHANGE_DELIVERY_HOME',
    SET_CHANGE_RETURN_BOXES: '[Order change] SET_CHANGE_RETURN_BOXES',
    SET_UPDATED_CHANGEABLE_ITEMS: '[Order change] SET_UPDATED_CHANGEABLE_ITEMS',

    CHANGE_CONFIRMATION: '[Order-change] CHANGE_CONFIRMATION',
    CHANGE_CONFIRMATION_SUCCESS: '[Order change] CHANGE_CONFIRMATION_SUCCESS',
    CHANGE_CONFIRMATION_ERROR_MODAL: '[Order change] CHANGE_CONFIRMATION_ERROR',
    BACK_CHANGES_PAGE: '[Order change] BACK_CHANGES_PAGE',
    SET_CHANGES_ACTIVE_BUTTON: '[Order change] SET_CHANGES_ACTIVE_BUTTON',
};

export const SetChangeOrder = createAction(OrderChangeActions.SET_CHANGE_ORDER, props<{ order: Order }>());
export const SetChangeStep = createAction(OrderChangeActions.SET_CHANGE_STEP, props<{ step: OrderChangeStep }>());
export const SetChangeSelectedItem = createAction(OrderChangeActions.SET_SELECTED_ITEM, props<{ index: number }>());
export const NextChangeStep = createAction(OrderChangeActions.NEXT_CHANGE_STEP, props<{ step: OrderChangeStep }>());
export const SetChangeReturnOption = createAction(OrderChangeActions.SET_CHANGE_RETURN_OPTION, props<{ optionReturn: OrderChangeOption }>());
export const SetChangeDeliveryOption = createAction(OrderChangeActions.SET_CHANGE_DELIVERY_OPTION, props<{ optionDelivery: OrderChangeOption }>());
export const SetChangeReturnPoint = createAction(OrderChangeActions.SET_CHANGE_RETURN_POINT, props<{ pickUpReturnPoint: PickupPointInfo }>());
export const SetChangeDeliveryPoint = createAction(OrderChangeActions.SET_CHANGE_DELIVERY_POINT, props<{ pickUpDeliveryPoint: PickupPointInfo }>());
export const SetChangeReturnStore = createAction(OrderChangeActions.SET_CHANGE_RETURN_STORE, props<{ storeReturnPoint: PhysicalStoreDetail }>());
export const SetChangeDeliveryStore = createAction(OrderChangeActions.SET_CHANGE_DELIVERY_STORE, props<{ storeDeliveryPoint: PhysicalStoreDetail }>());
export const SetChangeReturnHome = createAction(OrderChangeActions.SET_CHANGE_RETURN_HOME, props<{ homeReturnPoint: Address }>());
export const SetChangeDeliveryHome = createAction(OrderChangeActions.SET_CHANGE_DELIVERY_HOME, props<{ homeDeliveryPoint: Address }>());
export const SetChangeReturnBoxes = createAction(OrderChangeActions.SET_CHANGE_RETURN_BOXES, props<{ boxes: number }>());

export const SetOrderChangeAddress = createAction(OrderChangeActions.SET_ORDER_CHANGE_ADDRESS, props<{
    address: Address;
}>());
export const SetSelectedColor = createAction(OrderChangeActions.SET_SELECTED_COLOR, props<{
    index: number;
    color: ProductColor;
}>());
export const SetSelectedSize = createAction(OrderChangeActions.SET_SELECTED_SIZE, props<{
    index: number;
    size: ProductSize;
}>());
export const ChangeConfirmation = createAction(OrderChangeActions.CHANGE_CONFIRMATION);
export const ChangeConfirmationSuccess = createAction(OrderChangeActions.CHANGE_CONFIRMATION_SUCCESS);
export const ChangeConfirmationErrorModal = createAction(OrderChangeActions.CHANGE_CONFIRMATION_ERROR_MODAL, props<{ changeError: any }>());
export const SetUpdatedChangeableItems = createAction(OrderChangeActions.SET_UPDATED_CHANGEABLE_ITEMS, props<{ replaceItems: OrderChangeItem[] }>());
export const BackChangesPage = createAction(OrderChangeActions.BACK_CHANGES_PAGE);
export const SetChangesActiveButton = createAction(OrderChangeActions.SET_CHANGES_ACTIVE_BUTTON, props<{ status: boolean }>());
